/* eslint-disable check-file/filename-blocklist */
import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	emptyComment: {
		id: 'comment-section.empty',
		description: 'Message to be displayed when user tries to comment without any content',
		defaultMessage: 'Comment text is empty. Cannot create empty comments.',
	},
	errorTitle: {
		id: 'comment-section.title',
		defaultMessage: 'We couldn’t save your comment',
		description: 'Generic title for all Error messages for Page comments',
	},
	deleteErrorTitle: {
		id: 'comment-section-delete.title',
		defaultMessage: 'We couldn’t delete your comment',
		description: 'Title to display when Delete page comment fails',
	},
	genericError: {
		id: 'comment-section.generic-error',
		description:
			'Generic Error displayed when saving or deleting comment fails for unhandled cases',
		defaultMessage:
			'If the problem persists, contact {atlassianSupportLink} or your space admin so they can troubleshoot the issue.',
	},
	editVersionError: {
		id: 'comment-section.edit-version-warning',
		description: 'Message displayed to User when they Edit a comment thats outdated',
		defaultMessage:
			// TODO: replace straight quotes with curly quotes (see go/curlyquotes)
			// eslint-disable-next-line no-restricted-syntax
			"You aren't editing the latest version of your comment. Copy your text, {refresh} the page, and save your comment again.",
	},
	editNotFoundError: {
		id: 'comment-section.edit-not-found-warning',
		description: 'Message displayed to User when they Edit a comment thats deleted',
		defaultMessage:
			// TODO: replace straight quotes with curly quotes (see go/curlyquotes)
			// eslint-disable-next-line no-restricted-syntax
			"You're editing a comment that’s recently been deleted. {Refresh} the page to see the latest page comments.",
	},
	replyError: {
		id: 'comment-section.reply-warning',
		description: 'Message displayed to User when they Reply to a comment thats deleted',
		defaultMessage:
			// TODO: replace straight quotes with curly quotes (see go/curlyquotes)
			// eslint-disable-next-line no-restricted-syntax
			"You're replying to a comment that’s recently been deleted. {Refresh} the page to see the latest page comments.",
	},
	permissionsError: {
		id: 'comment-section.permission-warning',
		description:
			"Message displayed to User when they get an error indicating they don't have permissions to add the comment",
		defaultMessage: 'You don’t have permission to comment here.',
	},
	editCommentNotFound: {
		id: 'comment-section-edit.not.found',
		defaultMessage: 'The comment you are trying to edit cannot be found. It may have been deleted.',
		description:
			'User visits a page/blog through an email or link to edit comment and comment does not exist',
	},
	userUnauthorizedError: {
		id: 'comment-section.user-unauthorized',
		description:
			'Message displayed to User when they get an error indicating their session has expired',
		defaultMessage: 'Your session expired, and you need to {refresh} the page before continuing.',
	},
	rateLimitError: {
		id: 'comment-section.rate-limit',
		description: 'Message displayed to User when they get a Rate Limiting error',
		defaultMessage:
			'Rate limit reached. Wait a minute or so while the system resets, then {refresh} the page',
	},
	viewCommentErrorMessage: {
		id: 'comment-section.view-comment-error',
		description: 'Message shown to users when View comment fails to load due to an expected error',
		defaultMessage:
			// TODO: replace straight quotes with curly quotes (see go/curlyquotes)
			// eslint-disable-next-line no-restricted-syntax
			"We're having trouble loading comments. Refresh the page and try again. ",
	},
	pageCommentSingular: {
		id: 'comment-section.comment-singular',
		description: 'label for a single page comment',
		defaultMessage: '1 page comment',
	},
	pageCommentPlural: {
		id: 'comment-section.comment-plural',
		description: 'label for multiple page comments',
		defaultMessage: '{totalComments, number} page comments',
	},
	pageCommentSortNewest: {
		id: 'comments-section.page-comments-newest',
		defaultMessage: 'Newest',
		description: 'Order by newest comment',
	},
	pageCommentSortOldest: {
		id: 'comments-section.page-comments-oldest',
		defaultMessage: 'Oldest',
		description: 'Order by oldest comment',
	},
});
